<div class="confirmation-wrapper">
    <div class="icon-cntnr">
        <div class="delete-icon"></div>
    </div>
    <div class="heading">
        <span>{{'common.delete' | translate}}</span>
    </div>
    <div class="message">
        {{message}}
    </div>
    <div class="warning">
        {{warning}}
    </div>
    <div class="prompt-msg">
        <span>{{'common.delete_msg' | translate}}?</span>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onDismiss()">{{'common.cancel' | translate}}</button>
        <button class="yes-btn" mat-raised-button color="primary" (click)="onConfirm()">
            {{'common.delete_cap' | translate}}</button>
    </div>
</div>